import { render, staticRenderFns } from "./SetTblColumns.vue?vue&type=template&id=2280058d"
import script from "./SetTblColumns.vue?vue&type=script&lang=js"
export * from "./SetTblColumns.vue?vue&type=script&lang=js"
import style0 from "./SetTblColumns.vue?vue&type=style&index=0&id=2280058d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports